export default __webpack_public_path__ + "static/media/etemplate.c7ec2035.svg";